import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Input,
  Table,
  Switch,
  Button,
  Modal,
  Badge,
  message,
  Tooltip,
  Select,
  Checkbox,
  TreeSelect,
  DatePicker,
} from "antd";
import moment from "moment-timezone";
import qs from "qs";

import classes from "./DocumentsEditor.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDocumentsSearchRequest,
  deleteDocumentRequest,
  activateDocumentRequest,
  unapproveDocumentRequest,
  getSitesRequest,
  getEtmfDocumentSchemaRequest,
  getEtmfDocumentSchemaFilterRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { documentManagementTableColsUpdate } from "../../reducers/document_management/actions";
import {
  getDocumentCreatePermission,
  getDocumentApprovePermission,
  getDocumentUnapprovePermission,
  getDocumentDeletePermission,
  getDocumentUpdatePermission,
  getDocumentTrainingReadPermission,
  getDocumentPublicReadPermission,
  getDocumentGeneralReadPermission,
  getDocumentGeneralPrivateReadPermission,
  getDocumentPerSiteReadPermission,
  getDocumentPerSitePrivateReadPermission,
  getDocumentValidationReadPermission,
  getDocumentPharmacyBinderPermission,
  getDocumentStudyRegulatoryBinderPermission,
} from "../../reducers/user/selectors";
import { getDimensionWidth } from "../../reducers/dimensions/selectors";
import { getDocumentManagementTableExcludedCols } from "../../reducers/document_management/selectors";
import DocumentForm, {
  documentTypes,
} from "../../components/DocumentForm/DocumentForm";
import DocumentApproveForm from "../../components/DocumentForm/DocumentApproveForm";
import DocumentVersions from "./DocumentsVersions";
import { withNamespaces } from "react-i18next";
import FileLink from "../../components/FileLink/FileLink";
import DocumentApproveStatus from "./DocumentApproveStatus";
import FolderView from "./FolderView";
import TableColsFilter from "./TableColsFilter";
import forEach from "lodash/forEach";

const { Content } = Layout;
const { Search } = Input;
const { TreeNode } = TreeSelect;
const { Option } = Select;
const ButtonGroup = Button.Group;

class DocumentsEditor extends React.Component {
  constructor(props) {
    super(props);

    const filtersByParse = get(
      qs.parse(this.props.location.search.replace("?", "")),
      "filter_by",
      []
    );
    const filtersBy = Array.isArray(filtersByParse)
      ? filtersByParse
      : [filtersByParse];

    const filtersValueParse = get(
      qs.parse(this.props.location.search.replace("?", "")),
      "filter_value",
      []
    );
    const filtersValueDirty = Array.isArray(filtersValueParse)
      ? filtersValueParse
      : [filtersValueParse];
    const filtersValue = map(filtersValueDirty, (item, index) => {
      let result;

      if (filtersBy[index] === 'expiry_year') {
        return moment(item);
      }

      try {
        result = JSON.parse(item);
      } catch (e) {
        result = item;
      }

      return result;
    });

    this.state = {
      documents: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: { columnKey: "order_index", order: "ascend" },
      documentEdit: null,
      documentApproveId: null,
      filterBy: null,
      filterValue: null,
      filtersBy: filtersBy,
      filtersValue: filtersValue,
      approvedSelected: null,
      etmfSchemaFilter: {},
      etmfSchema: {},
      etmfSchemaLimits: {},
      approveStatusDocumentId: null,
      documentHistory: null,
      contentTypeCode: null,
      showInactiveDocuments: false,
      view: "table",
    };
  }

  mapped_categories() {
    return {
      public: this.props.i18n.t("Public"),
      general: this.props.i18n.t("NamespaceDocumentsEditor:Central Shared"),
      general_private: this.props.i18n.t(
        "NamespaceDocumentsEditor:Central Private"
      ),
      per_site: this.props.i18n.t("NamespaceDocumentsEditor:Site Specific"),
      training: this.props.i18n.t("NamespaceDocumentsEditor:Training"),
      validation: this.props.i18n.t("NamespaceDocumentsEditor:Validation"),
      study_regulatory_binder: this.props.i18n.t("NamespaceDocumentsEditor:Study Regulatory Binder"),
      pharmacy_binder: this.props.i18n.t("NamespaceDocumentsEditor:Pharmacy Binder"),
    };
  }

  async componentDidMount() {
    this.onNameSearch();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });

      this.getETMFSchema();
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  }

  getETMFSchema = async () => {
    try {
      const { data: etmfSchema } = await getEtmfDocumentSchemaRequest();
      const {
        data: etmfSchemaFilter,
      } = await getEtmfDocumentSchemaFilterRequest(null, {
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });
      const etmfSchemaLimits = {};

      forEach(get(etmfSchema, "schema"), (category) => {
        forEach(category.sub_categories, (subCategory) => {
          forEach(subCategory.content_types, (contentTypes) => {
            if (
              contentTypes.limit_visibility_types &&
              contentTypes.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                contentTypes.limit_visibility_types;
            } else if (
              subCategory.limit_visibility_types &&
              subCategory.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                subCategory.limit_visibility_types;
            } else if (
              category.limit_visibility_types &&
              category.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                category.limit_visibility_types;
            }
          });
        });
      });

      this.setState({ etmfSchema, etmfSchemaLimits, etmfSchemaFilter });
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  };

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getDocuments
    );
  };

  getDocuments = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDocumentsSearchRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        include_inactive: this.state.showInactiveDocuments,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          documents: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          documents: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        documents: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getDocuments(pagination.current, pagination.pageSize)
    );
  };

  onDocumentEdit = (document) => () => {
    this.setState({ documentEdit: document });
  };

  onDocumentEditHide = () => {
    this.setState({ documentEdit: null });
  };

  onDocumentEditSubmit = () => {
    this.setState({ documentEdit: null, documentApproveId: null }, () => {
      this.getDocuments();
      this.getETMFSchema();
    });
  };

  onDocumentHistory = (document) => () => {
    this.setState({ documentHistory: document });
  };

  addDocument = () => {
    this.setState({ documentEdit: {} });
  };

  addDocumentWithParams = (documentEdit) => {
    this.setState({ documentEdit });
  };

  onSwitchDocumentActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deleteDocumentRequest(id);
      } else {
        await activateDocumentRequest(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.getDocuments();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  onSwitchDocumentApprove = (id, approved) => async () => {
    try {
      if (approved) {
        await unapproveDocumentRequest(id);
        this.getDocuments();
        message.success(this.props.i18n.t("Saved"));
      } else {
        this.setState({ documentApproveId: id });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  handleFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = (index) => (value) => {
    this.setState(
      (state) => {
        const filtersValue = cloneDeep(state.filtersValue);
        filtersValue[index] = value;
        return { filtersValue, currentPage: 1 };
      },
      () => {
        this.getDocuments();
        this.getETMFSchema();
      }
    );

    window.history.replaceState(null, null, window.location.pathname);
  };

  clearFilter = (index) => () => {
    this.setState(
      (state) => {
        const filtersBy = cloneDeep(state.filtersBy);
        const filtersValue = cloneDeep(state.filtersValue);

        filtersBy.splice(index, 1);
        filtersValue.splice(index, 1);

        return { filtersBy, filtersValue, currentPage: 1 };
      },
      () => {
        this.getDocuments();
        this.getETMFSchema();
      }
    );

    window.history.replaceState(null, null, window.location.pathname);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getDocuments);
    window.history.replaceState(null, null, window.location.pathname);
  };

  onSelectApprovedStatus = (approvedStatusType) => () => {
    let status;
    const { approvedSelected } = this.state;

    if (approvedSelected === null && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === true && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === false && approvedStatusType === "approved") {
      status = null;
    }

    if (approvedSelected === null && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === false && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === true && approvedStatusType === "unapproved") {
      status = null;
    }

    this.setState(
      (_) => ({ approvedSelected: status, currentPage: 1 }),
      () => {
        this.getDocuments();
        this.getETMFSchema();
      }
    );
  };

  renderFilterItem = ({ index = this.state.filtersBy.length, viewType }) => {
    const { filtersBy, filtersValue, sites, etmfSchemaFilter } = this.state;

    return !(
      viewType === "folderView" && filtersBy[index] === "content_type_code"
    ) ? (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Filter")} by
            </b>
            <Select
              onChange={this.handleFilterChange(index)}
              value={filtersBy[index]}
              style={{ width: "100%" }}
              disabled={
                viewType === "folderView" &&
                filtersBy[index] === "content_type_code"
              }
              placeholder={this.props.i18n.t("Select")}
            >
              <Option
                value="category"
                disabled={filtersBy.includes("category")}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Visibility")}
              </Option>
              {viewType !== "folderView" && (
                <Option
                  value="primary_category_code"
                  disabled={filtersBy.includes("primary_category_code")}
                >
                  {this.props.i18n.t("NamespaceDocumentsEditor:Primary category")}
                </Option>
              )}
              {viewType !== "folderView" && (
                <Option
                  value="sub_category_code"
                  disabled={filtersBy.includes("sub_category_code")}
                >
                  {this.props.i18n.t("NamespaceDocumentsEditor:Sub category")}
                </Option>
              )}
              {viewType !== "folderView" && (
                <Option
                  value="content_type_code"
                  disabled={filtersBy.includes("content_type_code")}
                >
                  {this.props.i18n.t("NamespaceDocumentsEditor:Content type")}
                </Option>
              )}
              {/*<Option value="type" disabled={filtersBy.includes("type")}>
                {this.props.i18n.t("Document type")}
              </Option>*/}
              <Option value="site" disabled={filtersBy.includes("site")}>
                {this.props.i18n.t("Site")}
              </Option>
              <Option value="state" disabled={filtersBy.includes("state")}>
                {this.props.i18n.t("State")}
              </Option>
              <Option
                value="extension"
                disabled={filtersBy.includes("extension")}
              >
                {this.props.i18n.t("Extension")}
              </Option>
              <Option
                value="expiry_year"
                disabled={filtersBy.includes("expiry_year")}
              >
                {this.props.i18n.t("Expiry date")}
              </Option>
            </Select>
          </label>
        </div>

        {filtersBy[index] === "id__in" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("ID")}
            </b>

            <Input value={filtersValue[index]} disabled />
          </label>
        )}

        {filtersBy[index] === "expiry_year" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Expiry date")}
            </b>

            <DatePicker
              value={filtersValue[index]}
              format="YYYY-MM-DD"
              allowClear={false}
              onChange={this.handleFilterValueChange(index)}
              disabledDate={(current) => {
                let customDate = moment().format("YYYY-MM-DD");
                return current && current < moment(customDate, "YYYY-MM-DD");
              }}
              renderExtraFooter={() => (
                <div style={{ padding: "8px 0 0" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      height: "23px",
                    }}
                  >
                    <Button
                      size="small"
                      type={
                        moment().add("7", "days").format("YYYY-MM-DD") ===
                        moment(filtersValue[index]).format("YYYY-MM-DD")
                          ? "primary"
                          : "secondary"
                      }
                      onClick={() => {
                        let customDate = moment().add("7", "days");
                        this.handleFilterValueChange(index)(customDate);
                      }}
                    >
                      7{" "}{this.props.i18n.t("days")}
                    </Button>
                    &nbsp;
                    <Button
                      size="small"
                      type={
                        moment().add("30", "days").format("YYYY-MM-DD") ===
                        moment(filtersValue[index]).format("YYYY-MM-DD")
                          ? "primary"
                          : "secondary"
                      }
                      onClick={() => {
                        let customDate = moment().add("30", "days");
                        this.handleFilterValueChange(index)(customDate);
                      }}
                    >
                      30{" "}{this.props.i18n.t("days")}
                    </Button>
                    &nbsp;
                    <Button
                      size="small"
                      type={
                        moment().add("90", "days").format("YYYY-MM-DD") ===
                        moment(filtersValue[index]).format("YYYY-MM-DD")
                          ? "primary"
                          : "secondary"
                      }
                      onClick={() => {
                        let customDate = moment().add("90", "days");
                        this.handleFilterValueChange(index)(customDate);
                      }}
                    >
                      90{" "}{this.props.i18n.t("days")}
                    </Button>
                  </div>
                </div>
              )}
            />
          </label>
        )}
        {filtersBy[index] === "category" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Visibility")}
            </b>
            <Select
              mode="multiple"
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              <Option
                value="public"
                disabled={!this.props.documentPublicReadPermission}
              >
                {this.props.i18n.t("Public")}
              </Option>
              <Option
                value="general"
                disabled={!this.props.documentGeneralReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Central Shared")}
              </Option>
              <Option
                value="general_private"
                disabled={!this.props.documentGeneralPrivateReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Central Private")}
              </Option>
              <Option
                value="per_site"
                disabled={!this.props.documentPerSiteReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Site Specific")}
              </Option>
              <Option
                value="per_site_private"
                disabled={!this.props.documentPerSitePrivateReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Site Specific Private")}
              </Option>
              <Option
                value="training"
                disabled={!this.props.documentTrainingReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Training")}
              </Option>
              <Option
                value="study_regulatory_binder"
                disabled={!this.props.documentStudyRegulatoryBinderPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Study Regulatory Binder")}
              </Option>
              <Option
                value="pharmacy_binder"
                disabled={!this.props.documentPharmacyBinderPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Pharmacy Binder")}
              </Option>
              <Option
                value="validation"
                disabled={!this.props.documentValidationReadPermission}
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Validation")}
              </Option>
            </Select>
          </label>
        )}

        {filtersBy[index] === "type" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsEditor:Document type")}
            </b>
            <Select
              mode="multiple"
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {Object.keys(documentTypes).map((key) => (
                <Option value={key} key={key}>
                  {documentTypes[key]}
                </Option>
              ))}
            </Select>
          </label>
        )}

        {filtersBy[index] === "primary_category_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsEditor:Primary category")}
            </b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {get(etmfSchemaFilter, "schema", []).map(({ name, code }) => (
                <Option key={code} value={code}>
                  {name}
                </Option>
              ))}
            </Select>
          </label>
        )}

        {filtersBy[index] === "sub_category_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsEditor:Sub category")}
            </b>
            <TreeSelect
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              placeholder={this.props.i18n.t("NamespaceDocumentsEditor:Select sub category")}
              style={{ width: "100%" }}
            >
              {get(etmfSchemaFilter, "schema", []).map(
                ({ code, name, sub_categories }) => (
                  <TreeNode
                    key={code}
                    title={<b style={{ color: "#777" }}>{name}</b>}
                    value={code}
                    selectable={false}
                  >
                    {sub_categories &&
                      sub_categories.length > 0 &&
                      sub_categories.map(({ name, code }) => (
                        <TreeNode key={code} title={name} value={code} />
                      ))}
                  </TreeNode>
                )
              )}
            </TreeSelect>
          </label>
        )}

        {filtersBy[index] === "content_type_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("NamespaceDocumentsEditor:Content type")}
            </b>
            <TreeSelect
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              placeholder={this.props.i18n.t("Select content type")}
              style={{ width: "100%" }}
              disabled={
                viewType === "folderView" &&
                filtersBy[index] === "content_type_code"
              }
            >
              {get(etmfSchemaFilter, "schema", []).map(
                ({ code, name, sub_categories }) => (
                  <TreeNode
                    key={code}
                    title={<b style={{ color: "#777" }}>{name}</b>}
                    value={code}
                    selectable={false}
                  >
                    {sub_categories &&
                      sub_categories.length > 0 &&
                      sub_categories.map(({ name, code, content_types }) => (
                        <TreeNode
                          key={code}
                          title={<b style={{ color: "#777" }}>{name}</b>}
                          value={code}
                          selectable={false}
                        >
                          {content_types &&
                            content_types.length > 0 &&
                            content_types.map(({ name, code }) => (
                              <TreeNode key={code} title={name} value={code} />
                            ))}
                        </TreeNode>
                      ))}
                  </TreeNode>
                )
              )}
            </TreeSelect>
          </label>
        )}

        {filtersBy[index] === "site" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Site")}
            </b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
              showSearch
              optionFilterProp="children"
              filterOption
            >
              {sites
                .sort(
                  (a, b) =>
                    +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                )
                .map((site) => (
                  <Option key={site.id} value={site.id}>
                    {site.code} - {site.name}
                  </Option>
                ))}
            </Select>
          </label>
        )}

        {filtersBy[index] === "state" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Active state")}</b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              <Option value="active">{this.props.i18n.t("Active")}</Option>
              <Option value="inactive">{this.props.i18n.t("Inactive")}</Option>
            </Select>
          </label>
        )}

        {filtersBy[index] === "approved" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Is approved")}</b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              <Option value="true">{this.props.i18n.t("Yes")}</Option>
              <Option value="false">{this.props.i18n.t("No")}</Option>
            </Select>
          </label>
        )}

        {filtersBy[index] === "extension" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Extension")}</b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
              showSearch
              optionFilterProp="children"
              filterOption
            >
              <Option value="docx">.docx</Option>
              <Option value="xlsx">.xlsx</Option>
              <Option value="pptx">.pptx</Option>
              <Option value="pdf">.pdf</Option>
              <Option value="odt">.odt</Option>
              <Option value="csv">.csv</Option>
              <Option value="txt">.txt</Option>
              <Option value="png">.png</Option>
              <Option value="jpg">.jpg</Option>
              <Option value="gif">.gif</Option>
              <Option value="mp4">.mp4</Option>
              <Option value="eml">.eml</Option>
              <Option value="msg">.msg</Option>
              <Option value="zip">.zip</Option>
              <Option value="xls">.xls</Option>
              <Option value="doc">.doc</Option>
              <Option value="ppt">.ppt</Option>
              <Option value="vsdx">.vsdx</Option>
              <Option value="xlsm">.xlsm</Option>
              <Option value="xlsx">.xlsx</Option>
              <Option value="accdb">.accdb</Option>
            </Select>
          </label>
        )}

        {filtersValue[index] &&
          !(
            viewType === "folderView" &&
            filtersBy[index] === "content_type_code"
          ) && (
            <span
              className={classes.clearButton}
              onClick={this.clearFilter(index)}
            >
              {this.props.i18n.t("Remove")}
            </span>
          )}
      </div>
    ) : (
      <div key={filtersBy[index]} />
    );
  };

  clearContentTypeCode = () => {
    this.setState({
      contentTypeCode: null,
    });
  };

  setContentTypeCode = (contentTypeCode) => {
    this.setState(
      () => {
        const filtersContentTypeIndex = this.state.filtersBy.findIndex(
          (item) => item === "content_type_code"
        );
        const filtersBy = [...this.state.filtersBy];
        const filtersValue = [...this.state.filtersValue];

        if (filtersContentTypeIndex !== -1) {
          filtersBy.splice(filtersContentTypeIndex, 1);
          filtersValue.splice(filtersContentTypeIndex, 1);
        }

        return {
          nameSearch: null,
          contentTypeCode,
          documents: [],
          currentPage: 1,
          filtersBy: ["content_type_code", ...filtersBy],
          filtersValue: [contentTypeCode, ...filtersValue],
        };
      },
      () => {
        if (contentTypeCode) {
          this.getDocuments();
        }
      }
    );
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      nameSearch,
      documents,
      currentPage,
      total,
      pageSize,
      documentEdit,
      sortedInfo,
      filtersBy,
      filtersValue,
      approvedSelected,
      etmfSchema,
      etmfSchemaLimits,
      etmfSchemaFilter,
      documentApproveId,
      approveStatusDocumentId,
      view,
    } = this.state;
    const { documentCreatePermission } = this.props;

    let columns = [
      {
        dataIndex: "order_index",
        key: "order_index",
        title: this.props.i18n.t("Index"),
        render: (val) => <span>{val}</span>,
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "order_index" && sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("Document Name"),
        render: (val, record) => (
          <div className={classes.nameDocumentWrapper}>
            <div style={{ width: "86px" }}>
              <Badge
                count={record.state}
                style={{
                  backgroundColor:
                    record.state === "active" ? "#52c41a" : "#777",
                }}
              />
              <br />
              {record.state === "active" && (
                <Badge
                  count={record.approved ? this.props.i18n.t("approved") : this.props.i18n.t("unapproved")}
                  style={{
                    backgroundColor: record.approved ? "#52c41a" : "#777",
                  }}
                />
              )}

              {record.expiry_year && (
                <div>
                  {moment(record.expiry_year) < moment() && (
                    <Badge
                      count={"Expired"}
                      style={{
                        backgroundColor: "#ff0000",
                      }}
                    />
                  )}
                  {/*{moment(record.expiry_year) < moment() ? (
                    <Badge
                      count={"Expired"}
                      style={{
                        backgroundColor: "#ff0000",
                      }}
                    />
                  ) : moment(record.expiry_year) <
                    moment().add("30", "days") ? (
                    <Badge
                      count={"Expires in 30 days"}
                      style={{
                        backgroundColor: "#f38749",
                      }}
                    />
                  ) : (
                    <div />
                  )}*/}
                </div>
              )}
            </div>

            <div>
              {val}

              {record.version && (
                <div className={classes.documentVersion}>
                  V.{record.version}
                </div>
              )}
            </div>
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "name" && sortedInfo.order,
      },
      {
        dataIndex: "extension",
        key: "extension",
        title: this.props.i18n.t("Extension"),
        render: (val) => <span>{val}</span>,
      },
      // {
      //   dataIndex: "type",
      //   key: "type",
      //   title: this.props.i18n.t("Document Type"),
      //   render: (val) => <span>{documentTypes[val]}</span>,
      //   sorter: true,
      //   sortOrder: get(sortedInfo, "columnKey") === "type" && sortedInfo.order,
      // },
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t("Site"),
        render: (site) => get(site, "name"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "site" && sortedInfo.order,
      },
      {
        dataIndex: "visibility",
        key: "visibility",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Visibility"),
        // render: (category) =>
        //   category ? this.mapped_categories()[category] || "" : "",
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "visibility" && sortedInfo.order,
      },
      {
        dataIndex: "start_year",
        key: "start_year",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Start date"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "start_year" && sortedInfo.order,
      },
      {
        dataIndex: "expiry_year",
        key: "expiry_year",
        title: this.props.i18n.t("Expiry date"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "start_year" && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "actions",
        title: this.props.i18n.t("Actions"),
        render: (val, document) => (
          <div className={classes.actions}>
            <FileLink url={document.url} />
            &nbsp; &nbsp;
            <Tooltip placement="topLeft" title={this.props.i18n.t("NamespaceDocumentsEditor:Edit Document")}>
              <Icon
                type="edit"
                theme="filled"
                className={classes.iconEdit}
                onClick={this.onDocumentEdit(document)}
              />
            </Tooltip>
            &nbsp; &nbsp;
            <Tooltip placement="topLeft" title={this.props.i18n.t("Versions")}>
              <Icon
                type="history"
                className={classes.iconEdit}
                onClick={this.onDocumentHistory(document)}
              />
            </Tooltip>
            &nbsp; &nbsp; &nbsp; &nbsp;
            {document.state === "active" && (
              <Button
                size="small"
                onClick={() => {
                  this.setState({ approveStatusDocumentId: val });
                }}
              >
                {this.props.i18n.t("Show approve status")}
              </Button>
            )}
            &nbsp; &nbsp;
            <div style={{ width: "90px", display: "flex" }}>
              {((this.props.documentUpdatePermission &&
                document.state === "inactive") ||
                (this.props.documentDeletePermission &&
                  document.state === "active")) && (
                <div>
                  <b className={classes.switchLabel}>
                    {this.props.i18n.t("State")}
                  </b>
                  <br />
                  <Tooltip
                    placement="topLeft"
                    title={this.props.i18n.t("NamespaceDocumentsEditor:Activate / Deactivate Document")}
                  >
                    <Switch
                      className={classes.reactivateBtn}
                      checked={document.state === "active"}
                      onChange={this.onSwitchDocumentActivation(
                        val,
                        document.state
                      )}
                    />
                  </Tooltip>
                </div>
              )}
              &nbsp; &nbsp;
              {document.state === "active" &&
                ((this.props.documentApprovePermission && !document.approved) ||
                  (this.props.documentUnapprovePermission &&
                    document.approved)) && (
                  <div>
                    <b className={classes.switchLabel}>
                      {this.props.i18n.t("Approve")}
                    </b>
                    <br />
                    <Tooltip
                      placement="topLeft"
                      title={this.props.i18n.t(
                        "NamespaceDocumentsEditor:Approve / Unapprove Document"
                      )}
                    >
                      <Switch
                        className={classes.reactivateBtn}
                        checked={document.approved}
                        onChange={this.onSwitchDocumentApprove(
                          val,
                          document.approved
                        )}
                      />
                    </Tooltip>
                  </div>
                )}
            </div>
          </div>
        ),
      },
    ];

    if (view === "table") {
      columns.splice(2, 0, {
        dataIndex: "primary_category_name",
        key: "primary_category_name",
        title: this.props.i18n.t("Сategory name"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "primary_category_name" &&
          sortedInfo.order,
      });
      columns.splice(3, 0, {
        dataIndex: "sub_category_name",
        key: "sub_category_name",
        title: this.props.i18n.t("Subcategory name"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "sub_category_name" &&
          sortedInfo.order,
      });
      columns.splice(4, 0, {
        dataIndex: "content_type_name",
        key: "content_type_name",
        title: this.props.i18n.t("Content type"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "content_type_name" &&
          sortedInfo.order,
      });
    }

    if (this.props.dimensionWidth < 768) {
      const contentTypeIndex = columns.findIndex(
        ({ key }) => key === "content_type_name"
      );

      if (!!~contentTypeIndex) {
        columns = [
          columns[1],
          columns[contentTypeIndex],
          columns[columns.length - 1],
        ];
      } else {
        columns = [columns[1], columns[columns.length - 1]];
      }
    }

    const columnsFiltered = cloneDeep(columns);

    Object.keys(this.props.documentManagementTableExcludedCols).forEach(
      (item) => {
        if (this.props.documentManagementTableExcludedCols[item]) {
          if (!!~columnsFiltered.findIndex(({ key }) => key === item)) {
            columnsFiltered.splice(
              columnsFiltered.findIndex(({ key }) => key === item),
              1
            );
          }
        }
      }
    );

    columnsFiltered[columnsFiltered.length - 1].title = (
      <div className={classes.actionCol}>
        <div style={{ marginRight: "15px" }}>Actions</div>

        <TableColsFilter
          documentManagementTableExcludedCols={
            this.props.documentManagementTableExcludedCols
          }
          documentManagementTableColsUpdate={
            this.props.documentManagementTableColsUpdate
          }
          columns={columns}
        />
      </div>
    );

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceDocumentsEditor:Trial Documents")}
            </h3>

            <div style={{ margin: "20px 0" }}>
              <ButtonGroup>
                <Button
                  type={view === "table" ? "primary" : "secondary"}
                  onClick={() => {
                    this.setState(
                      {
                        view: "table",
                        nameSearch: null,
                        documents: null,
                        currentPage: 1,
                        filtersBy: [],
                        filtersValue: [],
                      },
                      () => {
                        this.getETMFSchema();
                        this.getDocuments();
                      }
                    );
                  }}
                >
                  {view === "table" && <Icon type="check-circle" />}
                  {this.props.i18n.t("NamespaceDocumentsEditor:Table view")}
                </Button>
                <Button
                  type={view === "folder" ? "primary" : "secondary"}
                  onClick={() => {
                    this.setState(
                      {
                        view: "folder",
                        nameSearch: null,
                        currentPage: 1,
                        filtersBy: [],
                        filtersValue: [],
                        contentTypeCode: null,
                      },
                      () => {
                        this.getETMFSchema();
                        this.getDocuments();
                      }
                    );
                  }}
                >
                  {view === "folder" && <Icon type="check-circle" />}
                  {this.props.i18n.t("NamespaceDocumentsEditor:Folder view")}
                </Button>
              </ButtonGroup>
            </div>

            {view === "folder" && (
              <FolderView
                documentCreatePermission={this.props.documentCreatePermission}
                etmfSchema={etmfSchema}
                etmfSchemaFilter={etmfSchemaFilter}
                addDocumentWithParams={this.addDocumentWithParams}
                setContentTypeCode={this.setContentTypeCode}
                clearContentTypeCode={this.clearContentTypeCode}
                etmfSchemaLimits={etmfSchemaLimits}
                onSubmit={this.onDocumentEditSubmit}
                onCancel={this.onDocumentEditHide}
                filters={
                  <div className={classes.wrapperFilters}>
                    <div className={classes.searchWrapperFilterItemApprove}>
                      <Checkbox
                        onChange={this.onSelectApprovedStatus("approved")}
                        checked={
                          approvedSelected === null || approvedSelected === true
                        }
                      >
                        {this.props.i18n.t("NamespaceDocumentsEditor:Approved")}
                      </Checkbox>
                      <Checkbox
                        onChange={this.onSelectApprovedStatus("unapproved")}
                        checked={!approvedSelected}
                      >
                        {this.props.i18n.t(
                          "NamespaceDocumentsEditor:Unapproved"
                        )}
                      </Checkbox>
                    </div>
                    {filtersBy.map((_, index) =>
                      this.renderFilterItem({ index, viewType: "folderView" })
                    )}

                    {filtersBy.length === filtersValue.length &&
                      filtersBy.length !== 5 &&
                      this.renderFilterItem({ viewType: "folderView" })}
                  </div>
                }
              />
            )}

            {view === "table" && (
              <div>
                <div className={classes.searchWrapper}>
                  <label className={classes.searchWrapperSearch}>
                    <b className={classes.searchWrapperLabel}>
                      {this.props.i18n.t("SEARCH")}
                    </b>
                    <Search
                      placeholder={this.props.i18n.t("By name")}
                      enterButton={this.props.i18n.t("Search")}
                      size="large"
                      onSearch={this.onNameSearch}
                      value={nameSearch}
                      onChange={this.onNameChange}
                      style={{ maxWidth: "500px" }}
                    />
                  </label>

                  <span
                    className={classes.clearButton}
                    onClick={this.clearFilters}
                  >
                    {this.props.i18n.t("Clear")}
                  </span>
                </div>

                <h4 className="headline-default">
                  {this.props.i18n.t("Filter")}
                </h4>

                <div className={classes.wrapperFilters}>
                  <div className={classes.searchWrapperFilterItemApprove}>
                    <Checkbox
                      onChange={this.onSelectApprovedStatus("approved")}
                      checked={
                        approvedSelected === null || approvedSelected === true
                      }
                    >
                      {this.props.i18n.t("NamespaceDocumentsEditor:Approved")}
                    </Checkbox>
                    <Checkbox
                      onChange={this.onSelectApprovedStatus("unapproved")}
                      checked={!approvedSelected}
                    >
                      {this.props.i18n.t("NamespaceDocumentsEditor:Unapproved")}
                    </Checkbox>
                  </div>

                  <div className={classes.searchWrapperFilterItemApprove}>
                    <Checkbox
                      onChange={() => {
                        this.setState(
                          {
                            showInactiveDocuments: !this.state
                              .showInactiveDocuments,
                          },
                          () => {
                            this.getETMFSchema();
                            this.getDocuments();
                          }
                        );
                      }}
                      checked={this.state.showInactiveDocuments}
                    >
                      {this.props.i18n.t("NamespaceDocumentsEditor:Show inactive documents")}
                    </Checkbox>
                  </div>

                  {filtersBy.map((_, index) =>
                    this.renderFilterItem({ index })
                  )}

                  {filtersBy.length === filtersValue.length &&
                    filtersBy.length !== 8 &&
                    this.renderFilterItem({})}
                </div>

                {errorMessage && (
                  <Alert
                    type="error"
                    message={errorMessage}
                    className={classes.alert}
                  />
                )}

                {responseMessage && (
                  <Alert
                    type="success"
                    message={responseMessage}
                    className={classes.alert}
                  />
                )}

                {documentCreatePermission && (
                  <div>
                    <Button type="primary" onClick={this.addDocument}>
                      {this.props.i18n.t("Add new document")}
                    </Button>
                  </div>
                )}
              </div>
            )}

            {(view === "table" || this.state.contentTypeCode) && (
              <div className={classes.tableWrapper}>
                <Table
                  columns={columnsFiltered}
                  dataSource={documents}
                  loading={isLoading}
                  rowKey="id"
                  onChange={this.handleTableChange}
                  pagination={{
                    onShowSizeChange: (current, size) => {
                      this.setState({ pageSize: size });
                    },
                    current: currentPage,
                    total,
                    pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                    position: "both",
                  }}
                />
              </div>
            )}

            {/*{isLoading && <Icon type="loading" />}*/}

            <Modal
              visible={!!documentEdit}
              onCancel={this.onDocumentEditHide}
              footer={null}
            >
              {documentEdit && (
                <DocumentForm
                  {...documentEdit}
                  etmfSchema={etmfSchema}
                  etmfSchemaLimits={etmfSchemaLimits}
                  onSubmit={this.onDocumentEditSubmit}
                  onCancel={this.onDocumentEditHide}
                  isNew={documentEdit && !documentEdit.id}
                />
              )}
            </Modal>
            <Modal
              visible={!!approveStatusDocumentId}
              onCancel={() => {
                this.setState({
                  approveStatusDocumentId: null,
                });
              }}
              footer={null}
            >
              {approveStatusDocumentId && (
                <DocumentApproveStatus id={approveStatusDocumentId} />
              )}
            </Modal>
            <Modal
              visible={!!documentApproveId}
              onCancel={() => {
                this.setState({ documentApproveId: null });
              }}
              footer={null}
            >
              {documentApproveId && (
                <DocumentApproveForm
                  id={documentApproveId}
                  onSubmit={this.onDocumentEditSubmit}
                  onCancel={() => {
                    this.setState({ documentApproveId: null });
                  }}
                />
              )}
            </Modal>
            <Modal
              visible={!!this.state.documentHistory}
              onCancel={() => {
                this.setState({ documentHistory: null });
              }}
              width={760}
              footer={null}
            >
              {this.state.documentHistory && (
                <DocumentVersions
                  {...this.state.documentHistory}
                  onCancel={() => {
                    this.setState({ documentHistory: null });
                  }}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  documentCreatePermission: getDocumentCreatePermission(state),
  documentApprovePermission: getDocumentApprovePermission(state),
  documentUnapprovePermission: getDocumentUnapprovePermission(state),
  documentDeletePermission: getDocumentDeletePermission(state),
  documentUpdatePermission: getDocumentUpdatePermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  documentGeneralReadPermission: getDocumentGeneralReadPermission(state),
  documentGeneralPrivateReadPermission: getDocumentGeneralPrivateReadPermission(
    state
  ),
  documentPerSiteReadPermission: getDocumentPerSiteReadPermission(state),
  documentPerSitePrivateReadPermission: getDocumentPerSitePrivateReadPermission(state),
  documentValidationReadPermission: getDocumentValidationReadPermission(state),
  documentPharmacyBinderPermission: getDocumentPharmacyBinderPermission(state),
  documentStudyRegulatoryBinderPermission: getDocumentStudyRegulatoryBinderPermission(
    state
  ),
  dimensionWidth: getDimensionWidth(state),
  documentManagementTableExcludedCols: getDocumentManagementTableExcludedCols(
    state
  ),
});
const mapDispatchToProps = { logout, documentManagementTableColsUpdate };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentsEditor))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentsEditor/DocumentsEditor.js